import {withStyles} from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'
import computer from './computer.png'
import React from 'react'
require('typeface-roboto')
const couponOutline = require('./animation2.gif');

const styles = {
  card: {
    display: 'inline-block',
    flexBasis: '25%',
    flexGrow: 1,
    flexShrink: 1,
    backgroundColor: '#000',
    opacity:.9,
    color:'#fff',
    margin: 26,
    marginLeft:28,
    maxWidth: 250,
    minWidth: 250

  },
  content: {
    zIndex:1,

    maxHeight:220,
    minHeight: 220
  },
  mediaWrapper: {
    height: 200,
    backgroundColor: '#fff',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center'
  },
  media: {
    height: '100%',
    width: '100%'
  }
}


const CouponCard = ({ data,classes }) => (
  <Card  className={classes.card}>

    <CardContent className={classes.content}>
      <Typography color='primary' gutterBottom style={{color:"#686ba8",textAlign:'center', fontSize:'18px'}} variant='overline' component='h1'>
        {data.title}
      </Typography>
      <hr />
      <Typography style={{textAlign:'center'}} variant ='overline'>
      {data.description}
      </Typography>
    </CardContent>
    <CardActions>

    </CardActions>
  </Card>
)

CouponCard.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(CouponCard)
